import model from 'modules/auth/userModel';

const { fields } = model;

export default [
  fields.email,
  fields.username,
  fields.firstName,
  fields.lastName,
  fields.phoneNumber,
  fields.externalId,
  fields.avatarsIam,
  fields.roles,
  fields.company,
];
